import { createFileRoute, notFound } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/idea-management/portals')({
  beforeLoad: async ({ context: { flags } }) => {
    if (!flags.fimPortalsEnabled) {
      throw notFound();
    }
  },
});
